package com.shadowings.gero.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.asSkiaBitmap
import kotlinx.browser.document
import org.jetbrains.skia.EncodedImageFormat
import org.jetbrains.skia.Image
import org.jetbrains.skia.Paint
import org.jetbrains.skia.Rect
import org.jetbrains.skia.Surface
import org.khronos.webgl.Int8Array
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

@Composable
actual fun rememberImageExporter(): (ImageBitmap, String) -> Unit {
    val isDarkMode = com.shadowings.gero.presentation.ui.LocalIsDarkMode.current
    return { bitmap, filename ->
        try {
            val skiaBitmap = bitmap.asSkiaBitmap()
            val width = skiaBitmap.width
            val height = skiaBitmap.height
            val surface = Surface.makeRasterN32Premul(width, height)
            val canvas = surface.canvas
            val paint = Paint().apply {
                color = if (isDarkMode) 0xFF15130B.toInt() else 0xFFFFF9EE.toInt()
            }
            canvas.drawRect(Rect.makeWH(width.toFloat(), height.toFloat()), paint)
            val originalImage = Image.makeFromBitmap(skiaBitmap)
            canvas.drawImage(originalImage, 0f, 0f)
            val snapshot = surface.makeImageSnapshot()
            val encodedData = snapshot.encodeToData(EncodedImageFormat.PNG, 100)

            originalImage.close()
            snapshot.close()
            paint.close()
            surface.close()

            val bytes = encodedData?.bytes
            if (bytes != null) {
                val blob = Blob(
                    arrayOf(Int8Array(bytes.toTypedArray())),
                    BlobPropertyBag(type = "image/png")
                )
                val url = URL.createObjectURL(blob)
                val anchor = document.createElement("a") as HTMLAnchorElement
                anchor.href = url
                anchor.download = "$filename.png"
                document.body?.appendChild(anchor)
                anchor.click()
                document.body?.removeChild(anchor)
                URL.revokeObjectURL(url)
            }
        } catch (e: Throwable) {
            e.printStackTrace()
        }
    }
}
